import React, { useState } from 'react'
import { Form } from 'react-final-form'
import { Button, Grid, Checkbox, TextField, FormControlLabel } from '@material-ui/core'
import 'react-datepicker/dist/react-datepicker.css'
import { useTranslation } from 'react-i18next'
import { filterStyles } from './FilterStyles'
import { useSelector, useDispatch } from 'react-redux'
import {
    filterByChargerId,
    filterHearthBeat,
    filterByFrom,
    filterByTill,
    filterByType,
    filterShowRaw,
} from '../../../redux/actions/logs'
import DatePicker from 'react-datepicker'
import { OptionsType, ValueType } from 'react-select'
import CreatableSelect from 'react-select/creatable'

export default function LogsFilter() {
    const { t } = useTranslation()
    const classes = filterStyles()
    const dispatch = useDispatch()

    const logsFilter = useSelector((state: any) => state.logs.filter)

    const [startDate, setStartDate] = useState(logsFilter.from.value)
    const [endDate, setEndDate] = useState(logsFilter.till.value)
    const [chargerId, setChargerId] = useState(logsFilter.chargerId.value || '')
    const [type, setType] = useState(logsFilter.type.value)
    const [showHeartbeat, setShowHeartbeat] = useState(logsFilter.showHeartbeat.value)
    const [showRaw, setShowRaw] = useState(logsFilter.showRaw.value)

    const onFormSubmit = () => {
        dispatch(filterByChargerId(chargerId))
        dispatch(filterByType(type))
        dispatch(filterByFrom(startDate))
        dispatch(filterByTill(endDate))
        dispatch(filterHearthBeat(showHeartbeat))
        dispatch(filterShowRaw(showRaw))
    }
    const handleFilterReset = () => {
        setChargerId('')
        setType('')
        setStartDate(null)
        setEndDate(null)
        setShowHeartbeat(true)

        dispatch(filterByChargerId(null))
        dispatch(filterByType(''))
        dispatch(filterByFrom(null))
        dispatch(filterByTill(null))
        dispatch(filterHearthBeat(true))
        dispatch(filterShowRaw(true))
    }


    const handleChargerIdChanged = (newChargerId: any) => {
        setChargerId(newChargerId.target.value)
    }

    const handleTypeChanged = (
        option: ValueType<LogTypeOption, false>
    ) => {
        const type = option?.value ?? ''
        setType(type)
        dispatch(filterByType(type))
    }

    const handleSearchFromChange = (newFrom: any) => {
        setStartDate(newFrom)
        dispatch(filterByFrom(newFrom))
    }

    const handleSearchTillChange = (newTill: any) => {
        setEndDate(newTill)
        dispatch(filterByTill(newTill))
    }

    const handleShowHeartbeatChange = () => {
        setShowHeartbeat(!showHeartbeat)
        dispatch(filterHearthBeat(!showHeartbeat))
    }

    const handleShowRawChange = () => {
        setShowRaw(!showRaw)
        dispatch(filterShowRaw(!showRaw))
    }

    interface LogTypeOption {
        value: string
        label: string
    }

    // Taken from c# enum ChargingStations.Domain.CentralSystem.Shared.MessageType
    const logTypeOptions: OptionsType<LogTypeOption> = [
        { value: 'None', label: 'None' },
        { value: 'Response', label: 'Response' },
        { value: 'Authorize', label: 'Authorize' },
        { value: 'BootNotification', label: 'BootNotification' },
        { value: 'Heartbeat', label: 'Heartbeat' },
        { value: 'StatusNotification', label: 'StatusNotification' },
        { value: 'MeterValues', label: 'MeterValues' },
        { value: 'StartTransaction', label: 'StartTransaction' },
        { value: 'StopTransaction', label: 'StopTransaction' },
        { value: 'RemoteStopTransaction', label: 'RemoteStopTransaction' },
        { value: 'RemoteStartTransaction', label: 'RemoteStartTransaction' },
        { value: 'ReopenTransaction', label: 'ReopenTransaction' },
        { value: 'Reset', label: 'Reset' },
        { value: 'UnlockConnector', label: 'UnlockConnector' },
        { value: 'ChangeAvailability', label: 'ChangeAvailability' },
        { value: 'SendLocalList', label: 'SendLocalList' },
        { value: 'GetDiagnostics', label: 'GetDiagnostics' },
        { value: 'GetConfiguration', label: 'GetConfiguration' },
        { value: 'DiagnosticsStatusNotification', label: 'DiagnosticsStatusNotification' },
        { value: 'ChangeConfiguration', label: 'ChangeConfiguration' },
        { value: 'SetChargingProfile', label: 'SetChargingProfile' },
        { value: 'ClearChargingProfile', label: 'ClearChargingProfile' },
        { value: 'SystemMaintenance', label: 'SystemMaintenance' },
        { value: 'Payment', label: 'Payment' },
        { value: 'Connection', label: 'Connection' },
        { value: 'Firebase', label: 'Firebase' },
        { value: 'Payload', label: 'Payload' },
        { value: 'TransactionStorage', label: 'TransactionStorage' },
        { value: 'C_to_B_Request', label: 'C_to_B_Request' },
        { value: 'B_to_C_Request', label: 'B_to_C_Request' },
        { value: 'C_to_B_Response', label: 'C_to_B_Response' },
        { value: 'B_to_C_Response', label: 'B_to_C_Response' },
        { value: 'Hubject', label: 'Hubject' },
        { value: 'Raw', label: 'Raw' },
        { value: 'InternalError', label: 'InternalError' },
        { value: 'FirmwareStatusNotification', label: 'FirmwareStatusNotification' },
        { value: 'DataTransfer', label: 'DataTransfer' },
        { value: 'VillaPro', label: 'VillaPro' },
        { value: 'QVend', label: 'QVend' }
    ]

    return (
        <Grid container className={classes.formWrapper}>
            <Grid item xs={12}>
                <Form
                    onSubmit={onFormSubmit}
                    render={({ handleSubmit, form }) => (
                        <form onSubmit={handleSubmit} noValidate>
                            <div className={classes.row}>
                                <div className={classes.field}>
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        className={classes.input}
                                        placeholder={t('logs.chargerId')}
                                        onChange={handleChargerIdChanged}
                                        value={chargerId}
                                        name="chargerId"
                                    />
                                </div>
                                <div className={classes.field}>
                                    <CreatableSelect
                                        // isMulti
                                        isClearable
                                        name="type"
                                        placeholder={t('logs.type')}
                                        options={logTypeOptions}
                                        onChange={handleTypeChanged}
                                        value={logTypeOptions.find((v) => v.value === type) || null}
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                minHeight: 42,
                                                backgroundColor: '#f5f5f5',
                                                borderColor: '#ddd',
                                                boxShadow: 'none',
                                            }),
                                            placeholder: (base) => ({ ...base, color: '#a2a2a2' }),
                                            menu: (base) => ({ ...base, zIndex: 10 }),
                                        }}
                                    />
                                </div>
                                <div className={`${classes.field} ${classes.datePickerWrapper}`}>
                                    <DatePicker
                                        onChange={handleSearchFromChange}
                                        selected={startDate}
                                        dateFormat="dd.MM.yyyy"
                                        placeholderText={`${t('logs.from')} dd.mm.yyyy`}
                                        customInput={<TextField fullWidth variant="filled" className={classes.input} />}
                                    />
                                </div>
                                <div className={`${classes.field} ${classes.datePickerWrapper}`}>
                                    <DatePicker
                                        onChange={handleSearchTillChange}
                                        selected={endDate}
                                        dateFormat="dd.MM.yyyy"
                                        placeholderText={`${t('logs.to')} dd.mm.yyyy`}
                                        customInput={<TextField fullWidth variant="filled" className={classes.input} />}
                                    />
                                </div>
                            </div>
                            <div className={`${classes.row} ${classes.secondRow}`}>
                                <FormControlLabel
                                    className={classes.checkboxLabel}
                                    control={
                                        <Checkbox
                                            className={classes.checkbox}
                                            style={{ color: '#6100ED' }}
                                            checked={showHeartbeat}
                                            onChange={handleShowHeartbeatChange}
                                        />
                                    }
                                    label={t('logs.showHeartbeat')}
                                />
                                <FormControlLabel
                                    className={classes.checkboxLabel}
                                    control={
                                        <Checkbox
                                            className={classes.checkbox}
                                            style={{ color: '#6100ED' }}
                                            checked={showRaw}
                                            onChange={handleShowRawChange}
                                        />
                                    }
                                    label={t('logs.showRaw')}
                                />
                                <div className={classes.buttons}>
                                    <Button className={classes.button} onClick={handleFilterReset} variant="outlined" color="primary">
                                        {t('logs.clearFilter')}
                                    </Button>
                                    <Button className={classes.button} variant="contained" color="primary" type="submit">
                                        {t('history.filter')}
                                    </Button>
                                </div>
                            </div>
                        </form>
                    )}
                />
            </Grid>
        </Grid>
    )
}
